import React from 'react';
import { useGetProjectQuery } from '../redux/features/projects/projectApi';
import Project from './Project';
import TeamMembersList from './TeamMembersList';

const Sidebar = () => {




  const {data,isError,isLoading}=useGetProjectQuery() || {};
 
  let content=null;
if(isLoading){
  content =<p>Loading...........</p>
}
else if(!isLoading && isError ){
  content =<p>Something went wrong !</p>
}
else if(!isLoading && !isError && data?.length > 0){

  
  content = data?.map(project=>  <Project project={project} key={project.id}/>)
}
  return (
    <aside><div className="sidebar">
 
  <div>
    <h3 className="text-xl font-bold">Projects</h3>
    <div className="mt-3 space-y-4">
     {content}
     
    </div>
  </div>
 
  <TeamMembersList/>
</div>
</aside>
  )
}

export default Sidebar